import { CustomerFeeScheduleDTO } from "../DTO/customerFeeScheduleDTO";

export class CustomerFeeSchedule{
    public id!: number;
    public customerId!: number;
    public billingTypeCode!: string;
    public amount!: number;
    public discountSchedule!: DiscountScheduleItem[];
    public added!: Date;
    public edited!: Date;

    constructor(){
        this.discountSchedule=[];
    }

    public static mapFromDTO(param: CustomerFeeScheduleDTO): CustomerFeeSchedule{
        if(!param) throw new Error("parameter is null")
        let obj = new CustomerFeeSchedule();
        try{
            obj.id = param.id;
            obj.customerId = param.customerId;
            obj.billingTypeCode = param.billingTypeCode;
            obj.amount = param.amount;
            let dsDTOArray:DiscountScheduleItemDTO[]=JSON.parse(param.discountSchedule);
            obj.discountSchedule = dsDTOArray.map(dto=>DiscountScheduleItem.mapFromDTO(dto));
            obj.added = new Date(param.added);
            obj.edited = new Date(param.edited);
        }
        catch(e){
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param: CustomerFeeSchedule):CustomerFeeScheduleDTO{
        if(!param) throw new Error("parameter is null")
        let dto = new CustomerFeeScheduleDTO();
        try {
            dto.id = param.id;
            dto.customerId = param.customerId;
            dto.billingTypeCode = param.billingTypeCode;
            dto.amount = param.amount;
            dto.discountSchedule = JSON.stringify(param.discountSchedule);
            dto.added = param.added.toISOString();
            dto.edited = param.edited.toISOString();
        } 
        catch (e) {
            console.log(e);
        }
        return dto;
    }
}

export class DiscountScheduleItem{
    public seqNo!: number;
    public discountPercent!: number;
    public until!: Date;

    public static mapFromDTO(param: DiscountScheduleItemDTO): DiscountScheduleItem{
        if(!param) throw new Error("parameter is null")
        let obj = new DiscountScheduleItem();
        try{
            obj.seqNo = param.seqNo;
            obj.discountPercent = param.discountPercent;
            obj.until = new Date(param.until);
        }
        catch(e){
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param: DiscountScheduleItem):DiscountScheduleItemDTO{
        if(!param) throw new Error("parameter is null")
        let dto = new DiscountScheduleItemDTO();
        try {
            dto.seqNo = param.seqNo;
            dto.discountPercent = param.discountPercent;
            dto.until = param.until.toISOString();
        } 
        catch (e) {
            console.log(e);
        }
        return dto;
    }
}

export class DiscountScheduleItemDTO{
    public seqNo!: number;
    public discountPercent!: number;
    public until!: string;
}